import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { AllocationLogsData } from '../../types/inventoryAllocationLogs'
import useStyles from './styles/AllocationHistoryTableHeader.styles'

interface AllocationHistoryTableHeaderProps {
  setPage(page: number): void
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      allocationLogs: AllocationLogsData
    }>
  >
}

export const AllocationHistoryTableHeader: React.FC<
  AllocationHistoryTableHeaderProps
> = ({ setPage, refetch }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('User Email')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>{getTranslate('Date')}</Typography>
      </div>
      <div>
        <Typography className={classes.text}>
          {getTranslate('Allocate Range')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Channel')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Accommodation')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Room Type')}
        </Typography>
      </div>

      <Typography className={classes.text} variant="body1">
        {getTranslate('Type')}
      </Typography>

      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Allocate Num')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Status')}
        </Typography>
      </div>
      <div />

      <div>
        <IconButton
          onClick={() => {
            refetch()
            setPage(1)
          }}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
